<template>
    <div class="row">
        <b-col cols="4"></b-col>
        <b-col cols="3" class="d-flex">
            <b-pagination
                @change="$emit('update:page', $event)"
                :total-rows="length"
                :per-page="perPage"
                :size="size"
                align="center"
                :value="page"
            />
            <b-form-select
                @change="updateItemsPerPage"
                :options="options"
                class="ml-2"
                value-field="items"
                text-field="text"
                :size="size"
                :value="perPage"
            ></b-form-select>
        </b-col>
        <b-col cols="5"></b-col>
    </div>
</template>

<script>
    import Size from "@/mixins/Size/Size";

    export default {
        name: 'Pagination',
        mixins: [Size],
        props: ["page", "length", "perPage", "options"],
        methods: {
            updateItemsPerPage(event) {
                this.$emit('update:perPage', event);
                this.$emit('update:page', 1);
            }
        }
    }
</script>